import React, {useEffect, useState} from 'react';
import {ArrowLeftOutlined,SaveOutlined,DeleteOutlined} from "@ant-design/icons";
import axios from "axios";
import {header} from "../../../../../../components/api/Header";
import {user_data} from "../../../../../../components/functions/usr";
import {NavLink} from "react-router-dom";
import swal from "sweetalert";
import {add_func} from "../../../../../../components/functions/Mathematik";
import { getEnv } from "../../../../../../lib/env";
function Add() {
    if(!user_data() || user_data().region_id != 16){
        window.location = '/limit/manbalar/jami'
    }
    const [hasData, setHasData] = useState(0)
    const [year, setYear] = useState('')
    const [lyear, setLyear] = useState(year)
    const [season, setSeason] = useState('veg')
    const [data, setData] = useState([])
    useEffect(()=>{
        const fetchData = async () => {
            const res = await axios.get(getEnv('REACT_APP_BASE_URL')+"/v1/region/limitmanbalar/jami?year="+year+"&season="+season, header())
                .catch(e=>{
                    console.log("Xato",e)
                    alert("Server bilan aloqa yo'q")
                })
            if(res){
                setData(res.data.data)
                setHasData(res.data.hasData)
            }
        }
        if(year){
            fetchData()
        }
    },[year,season])
    const setHandler = (v,i,d) => {
        let dat = [...data]
        if(dat[i]){
            dat[i][d] = v
            setChanged(true)
            dat[i]['jami'] = add_func(add_func(dat[i]['daryo'],dat[i]['ichki_daryo']),add_func(dat[i]['yer_osti'],dat[i]['qayta']))
        }

        setData(dat)
    }
    const [changed, setChanged] = useState(false)
    const doIt = async (action) => {
        const res = await axios.post(getEnv('REACT_APP_BASE_URL')+"/v1/region/limitmanbalar/"+action,{data,year,season}, header())
            .catch(e=>{
                console.log("Xato",e)
                alert("Server bilan aloqa yo'q!")
            })
        if(res){
            if(res.data.status == 200){
                swal("Muvaffaqiyalti", res.data.message, 'success')
                window.location = "/limit/manbalar/jami"
            }else{
                swal("Xato", res.data.message, 'error')
            }
        }
    }
    return (
        <>
            <div className="table-content-top">
                <div className="table-top-left d-flex align-items-center">
                    <NavLink to="/limit/manbalar/jami" className="btn btn-sm btn-outline-primary d-flex align-items-center">
                        <ArrowLeftOutlined />&nbsp;&nbsp;&nbsp;Qaytish
                    </NavLink>
                    &nbsp;&nbsp;&nbsp;
                    {
                        changed ? <button className="btn btn-sm btn-outline-primary d-flex align-items-center" onClick={()=>doIt('savejami')}>
                            Saqlash &nbsp;&nbsp;&nbsp;<SaveOutlined />
                        </button> :null
                    }
                    {
                        hasData ? <button className="btn btn-sm btn-outline-danger d-flex align-items-center" onClick={()=>doIt('deletejami')}>
                            O'chirish &nbsp;&nbsp;&nbsp;<DeleteOutlined />
                        </button> :null
                    }

                </div>
                <ul className="table-top-right">
                    <li className="d-flex align-items-center">
                        <input type="number" className="form-control form-control-sm" min={2015} max={parseInt(new Date().toISOString().slice(0,4))+2} value={lyear} onChange={e=>setLyear(e.target.value)}/>
                        &nbsp;&nbsp;&nbsp;
                        <button className="btn btn-sm btn-outline-primary" onClick={()=>setYear(lyear)}>Ok</button>
                    </li>
                    <li>
                        <select className="form-select form-select-sm" onChange={e=>setSeason(e.target.value)} value={season}>
                            <option value="veg">Sug'orish mavsumi</option>
                            <option value="noveg">Nosug'orish mavsumi</option>
                        </select>
                    </li>

                </ul>
            </div>
            <div className="table-responsive tableFixHead">
                <table className="table table-bordered table-style limit">
                    <thead>
                    <tr>
                        <th colSpan={7}>
                            O‘zbekiston Respublikasi bo‘yicha {year}-yilning {season == 'noveg' ? 'no' :null}vegetatsiya davrida suv manbalaridan jami ajratilgan suv olish limiti
                        </th>
                    </tr>
                    <tr>
                        <th scope="col" rowSpan={2}>№</th>
                        <th scope="col" rowSpan={2}>Tashkilot va hududlar nomi</th>
                        <th scope="col" rowSpan={2}>Jami suv olish limiti*</th>
                        <th scope="col" colSpan={4}> shu jumladan, manbalardan</th>
                    </tr>
                    <tr>
                        <th scope="col">Daryo o‘zanidan</th>
                        <th scope="col">Ichki daryo va soylardan</th>
                        <th scope="col">Yer osti suvlaridan</th>
                        <th scope="col">Qaytadan ishlatila-digan (zovur)</th>
                    </tr>
                    </thead>
                    {
                        data.length > 0?
                            data.map((d,i) => {
                                return <tbody key={i}>
                                <tr>
                                    <th>{i+1}</th>
                                    <th style={{width:'250px',minWidth:'250px'}}>
                                        <p><b>{d.name}</b></p>
                                        <p><i>{d.title}</i></p>
                                    </th>
                                    <th scope="col" className="inserttr">
                                        <input className="insertable" type="number" value={d.jami?d.jami:''} readOnly/>
                                    </th>
                                    <th scope="col" className="inserttr">
                                        <input className="insertable" type="number" value={d.daryo?d.daryo:''} onChange={e=>setHandler(e.target.value,i,'daryo')}/>
                                    </th>
                                    <th scope="col" className="inserttr">
                                        <input className="insertable" type="number" value={d.ichki_daryo?d.ichki_daryo:''} onChange={e=>setHandler(e.target.value,i,'ichki_daryo')}/>
                                    </th>
                                    <th scope="col" className="inserttr">
                                        <input className="insertable" type="number" value={d.yer_osti?d.yer_osti:''} onChange={e=>setHandler(e.target.value,i,'yer_osti')}/>
                                    </th>
                                    <th scope="col" className="inserttr">
                                        <input className="insertable" type="number" value={d.qayta?d.qayta:''} onChange={e=>setHandler(e.target.value,i,'qayta')}/>
                                    </th>
                                </tr>
                                </tbody>
                            })
                            :null
                    }
                </table>
            </div>
        </>
    );
}

export default Add;

